const DEV_DATABASE_SUFFIX = "_dev";

// the remote database name decides which environment the webadmin talks to
export const isDevDatabase = () => {
    const remoteDBName = process.env.REACT_APP_REMOTE_DB_NAME;

    return typeof remoteDBName === "string" && remoteDBName.endsWith(DEV_DATABASE_SUFFIX);
};
